const ASBESTOS_OPTIONS = {
  YES: 'YES',
  NO: 'NO',
  NOT_AVAILABLE: 'NOT_AVAILABLE',
};

export default ASBESTOS_OPTIONS;
